// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- this is where it's overridden
import { email } from 'react-admin';

export * from '@sh4res/bo-common/validators/date';
export * from '@sh4res/bo-common/validators/formValidationResolver';
export * from '@sh4res/bo-common/validators/phoneNumberValidator';

export const trimmedEmail = () => (value?: string) => {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '') {
      return undefined;
    }
    return email()(trimmed);
  }
  return undefined;
};
